<template>
    <div class="template-message-selector">
        <div class="title">{{ $t("whatsapp_business_api.selectATemplate") }}</div>
        <div class="d-flex gap-5">
            <a-select v-model="selectedTemplateId" style="width: 100%" :placeholder="$t('whatsapp.selectTemplateMessage')">
                <a-select-option v-for="template in templates" :key="template.id" :value="template.id">
                    {{ template.format === "meta" ? template.name : template.elementName }}
                </a-select-option>
            </a-select>
            <a-spin v-if="loading">
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
            </a-spin>
        </div>

        <a-divider />
        <TemplateCard :template="selectedTemplate" v-if="!!selectedTemplate" />
        <a-divider v-if="variables.length > 0" />
        <div class="variables-container" v-if="variables.length > 0">
            <label>{{ $t("whatsapp_business_api.variableSettings") }}</label>
            <div class="variables">
                <div class="variable" v-for="(variable, i) of variables" :key="i">
                    <label>{{ $t('whatsapp.variable') }} {{ i + 1 }} ==> </label>

                    <a-select
                        v-model="variables[i]"
                        style="width: 100%"
                        :placeholder="$t('whatsapp.selectVariable')"
                        v-if="fieldMode"
                    >
                        <a-select-option v-for="v in getAvailableParameters()" :key="v.id" :value="v.id">
                            {{ v.label }}
                        </a-select-option>
                    </a-select>
                    <a-select v-model="variables[i]" style="width: 100%" :placeholder="$t('whatsapp.selectVariable')" v-else>
                        <a-select-option v-for="v in getAvailableParameters()" :key="v" :value="v">
                            {{ v }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import TemplateCard from "../../../.././WhatsappBusinessGupshup/detail/TemplateCard.vue";
import log2 from "../../../../../../utils/log2";
import WHATSAPP_API from "../../../../../../api/whatsapp";

const log = log2("TemplateMessageSelector.vue");
export default Vue.extend({
    name: "TemplateMessageSelector",
    components: { TemplateCard },
    props: {
        channelId: {
            type: String,
            required: true,
        },
        value: {
            required: true,
        },
        fieldMode: {
            type: Boolean,
            default: false,
        },
        defaultFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        const templateParams = this.value?.templateParams || [];
        const varsArray = Array.isArray(templateParams) ? templateParams : [];
        
        return {
            loading: false,
            selectedTemplateId: null,
            selectedTemplate: null,
            clone: _.cloneDeep(this.value),
            variables: _.cloneDeep(varsArray),
            selectedCustomerGroup: null,
            templates: [],
        };
    },
    computed: {
        ...mapState({
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
            channels: (state) => state.channel.channels,
        }),
        channel(){
            return this.channels.find((x) => x._id === this.channelId);
        },
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        getCustomerGroupDetail() {
            if (this.value.groupId) {
                WHATSAPP_API.BROADCAST.getGroupById(this.value.groupId).then((res) => {
                    this.selectedCustomerGroup = res.data;
                });
            }
        },
        getAvailableParameters() {
            if (this.fieldMode) {
                return this.defaultFields;
            }
            if (this.selectedCustomerGroup) {
                const headContactAttributes = _.get(this.selectedCustomerGroup, "contacts.0.attributes", {}) || {};
                return Object.keys(headContactAttributes);
            }
            return [];
        },
        getParams(template) {
            if (!template) return [];
            
            try {
                const templateType = template.templateType;
                const containerMetaObj = template.containerMeta ? JSON.parse(template.containerMeta) : {};
                const headerText = _.get(containerMetaObj, "header", "");
                let cardVariableSize = 0;
                
                if (templateType === "CAROUSEL" && containerMetaObj.cards) {
                    const cards = containerMetaObj.cards;
                    cardVariableSize = cards
                        .map((card) => {
                            return card.body ? card.body.match(/{{\d+}}/g) : null;
                        })
                        .flat()
                        .filter(Boolean).length;
                }
                
                const buttonVariableSize = (containerMetaObj.buttons || [])
                    .filter((button) => button.type === "URL")
                    .map((button) => {
                        return button.url ? button.url.match(/{{\d+}}/g) : null;
                    })
                    .flat()
                    .filter(Boolean).length;
                
                const headerMatches = headerText ? headerText.match(/{{\d+}}/g) : null;
                const bodyMatches = template.data ? template.data.match(/{{\d+}}/g) : null;
                
                return [
                    ..._.uniq(headerMatches || []),
                    ..._.uniq(bodyMatches || []),
                    ...new Array(cardVariableSize).fill(null),
                    ...new Array(buttonVariableSize).fill(null),
                ].map(() => "");
            } catch (error) {
                console.error("getParams error:", error);
                return [];
            }
        },
    },
    mounted() {
        this.getCustomerGroupDetail();
        this.getTemplates(this.channelId).then((templates) => {
            this.templates = templates;
            if (this.templates.length > 0) {
                this.selectedTemplateId = this.templates[0].id;
            }
        });
    },
    watch: {
        selectedTemplateId(val) {
            const template = this.templates.find((x) => x.id === val);
            if (template) {
                this.selectedTemplate = template;
                const params = this.getParams(template);
                this.variables = params;
                this.clone.selectedTemplate = template;
                this.clone.templateParams = params;
            }
        },
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
        variables: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value.templateParams);
                    log("variables changed=>", { val, isChanged, old: this.value.templateParams });
                    if (isChanged) {
                        log("variables changed=>", val);
                        this.clone.templateParams = val;
                    }
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.variables-container {
    display: flex;
    flex-direction: column;
    gap: 10px;

    label {
        font-weight: bold;
    }

    .variables {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .variable {
            display: flex;
            gap: 5px;
            align-items: center;
            max-width: 500px;

            label {
                font-weight: bold;
                width: 150px;
            }
        }
    }
}
</style>
